import { render, staticRenderFns } from "./AppointExtractExpertModal.vue?vue&type=template&id=70fed1fe&scoped=true"
import script from "./AppointExtractExpertModal.vue?vue&type=script&lang=js"
export * from "./AppointExtractExpertModal.vue?vue&type=script&lang=js"
import style0 from "./AppointExtractExpertModal.vue?vue&type=style&index=0&id=70fed1fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fed1fe",
  null
  
)

export default component.exports